<!--临时客商新增  -->
<template>
	<div class="info-box">
		<el-dialog
			title="路线信息"
			v-if="dialogVisible"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			width="1000px"
			:before-close="cancle"
			top="3vh">
			<!-- 基础信息 -->
			<div class="form-box mt15 form-add" v-if="ruleForm.routeId == ''">
				<el-form label-position="right" :inline="true" size="small" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
					<el-form-item label="路线名称" prop="routeName">
						<el-input v-model="ruleForm.routeName" class="w280" maxlength="20"></el-input>
					</el-form-item>
					<el-form-item label="组织结构" prop="groupId">
						<el-select v-model="ruleForm.groupId" class="w280" size="small" placeholder="选择" @change="handleGroup">
							<el-option v-for="item in groupDate" :key="item.groupId" :label="item.groupName" :value="item.groupId"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="配送车辆" prop="licensePlate">
						<el-input v-model="ruleForm.licensePlate" class="w280" maxlength="16" readonly :disabled="ruleForm.groupId ? false : true">
							<i slot="suffix" :class="!ruleForm.groupId ? 'nonallowed' : ''" @click="handleCar" class="el-input__icon el-icon-search"></i>
						</el-input>
					</el-form-item>
					<el-form-item label="启用状态" prop="routeStatus">
						<el-select v-model="ruleForm.routeStatus" class="w280" size="small" placeholder="选择">
							<el-option label="正常" value="Y"></el-option>
							<el-option label="停用" value="N"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="主路线员" prop="mainUserCode">
						<el-input v-model="ruleForm.mainUserCode" class="w280" maxlength="16" readonly :disabled="ruleForm.groupId ? false : true">
							<i
								slot="suffix"
								:class="!ruleForm.groupId ? 'nonallowed' : ''"
								@click="handleRouteUser(1)"
								class="el-input__icon el-icon-search"></i>
						</el-input>
					</el-form-item>
					<el-form-item label="副路线员">
						<el-input v-model="ruleForm.secUserCode" class="w280" maxlength="16" readonly :disabled="ruleForm.groupId ? false : true">
							<i
								slot="suffix"
								:class="!ruleForm.groupId ? 'nonallowed' : ''"
								@click="handleRouteUser(2)"
								class="el-input__icon el-icon-search"></i>
							<i slot="suffix" v-if="ruleForm.secUserCode" @click="handleClear" class="el-input__icon el-icon-circle-close"></i>
						</el-input>
					</el-form-item>
					<el-form-item label="主路线员名">
						<el-input v-model="ruleForm.mainUserName" class="w280" maxlength="16" readonly></el-input>
					</el-form-item>
					<el-form-item label="副路线员名">
						<el-input v-model="ruleForm.secUserName" class="w280" maxlength="16" readonly></el-input>
					</el-form-item>
					<el-form-item label="路线类型" prop="routeType">
						<el-select v-model="ruleForm.routeType" class="w280" size="small" placeholder="选择">
							<el-option label="单人" value="1"></el-option>
							<el-option label="双人" value="2"></el-option>
							<el-option label="Min" value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="销售据点分类">
						<el-select v-model="ruleForm.routeTag1" class="w280" size="small" placeholder="选择">
							<el-option label="分公司" value="分公司"></el-option>
							<el-option label="外仓" value="外仓"></el-option>
							<el-option label="营业所" value="营业所"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="标签3">
						<el-input v-model="ruleForm.routeTag3" class="w280"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<!-- 基础信息 -->
			<div class="form-box mt15" v-else>
				<el-form label-position="right" :inline="true" size="small" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
					<el-form-item label="路线名称" prop="routeName">
						<el-input v-model="ruleForm.routeName" class="w210" maxlength="20"></el-input>
					</el-form-item>
					<el-form-item label="路线类型" prop="routeType">
						<el-select v-model="ruleForm.routeType" class="w210" size="small" placeholder="选择">
							<el-option label="单人" value="1"></el-option>
							<el-option label="双人" value="2"></el-option>
							<el-option label="Min" value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="启用状态" prop="routeStatus">
						<el-select v-model="ruleForm.routeStatus" class="w120" size="small" placeholder="选择">
							<el-option label="正常" value="Y"></el-option>
							<el-option label="停用" value="N"></el-option>
						</el-select>
						<el-button size="small" type="primary" class="ml35" @click="submitForm('ruleForm')">保存</el-button>
					</el-form-item>
					<el-form-item label="销售据点分类" v-if="ruleForm.routeId">
						<el-select v-model="ruleForm.routeTag1" class="w210" size="small" placeholder="选择">
							<el-option label="分公司" value="分公司"></el-option>
							<el-option label="外仓" value="外仓"></el-option>
							<el-option label="营业所" value="营业所"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="配送车辆" prop="licensePlate">
						<el-input v-model="ruleForm.licensePlate" class="w210" maxlength="16" readonly :disabled="ruleForm.groupId ? false : true">
							<i slot="suffix" :class="!ruleForm.groupId ? 'nonallowed' : ''" @click="handleCar" class="el-input__icon el-icon-search"></i>
						</el-input>
					</el-form-item>
					<el-form-item label="主路线员" prop="mainUserCode">
						<el-input v-model="ruleForm.mainUserCode" class="w120" maxlength="16" readonly :disabled="ruleForm.groupId ? false : true">
							<i
								slot="suffix"
								:class="!ruleForm.groupId ? 'nonallowed' : ''"
								@click="handleRouteUser(1)"
								class="el-input__icon el-icon-search"></i>
						</el-input>
						<el-input v-model="ruleForm.mainUserName" class="w80 ml10" maxlength="16" readonly></el-input>
					</el-form-item>
					<el-form-item label="标签3" v-if="ruleForm.routeId">
						<el-input v-model="ruleForm.routeTag3" class="w210"></el-input>
					</el-form-item>
					<el-form-item label="副路线员">
						<el-input v-model="ruleForm.secUserCode" class="w120" maxlength="16" readonly :disabled="ruleForm.groupId ? false : true">
							<i
								slot="suffix"
								:class="!ruleForm.groupId ? 'nonallowed' : ''"
								@click="handleRouteUser(2)"
								class="el-input__icon el-icon-search"></i>
							<i slot="suffix" v-if="ruleForm.secUserCode" @click="handleClear" class="el-input__icon el-icon-circle-close"></i>
						</el-input>
						<el-input v-model="ruleForm.secUserName" class="w80 ml10" maxlength="16" readonly></el-input>
					</el-form-item>
				</el-form>
			</div>
			<!-- 客商列表 -->
			<div v-if="ruleForm.routeId">
				<div class="info-title">
					<el-radio-group v-model="tabPosition">
						<el-radio-button label="left">客商调序</el-radio-button>
						<el-radio-button label="right">配送周期</el-radio-button>
					</el-radio-group>
					<img class="icon-img ml10" src="@/assets/images/map.png" @click="handleMap" title="地图" alt="" />
					<div class="f-r" v-show="tabPosition == 'left'">
						配送周期：
						<el-select
							v-model="deliveryCycle"
							class="w120"
							size="small"
							placeholder="选择"
							@change="changeDeliveryCycle"
							popper-class="week-select">
							<el-option label="全部" value=""></el-option>
							<el-option v-for="(v, i) in weeklist" :label="v.label" :value="v.value" :key="i"></el-option>
						</el-select>
						<img class="icon-img ml7" src="@/assets/images/delete.png" @click="deleteRow" title="删除" alt="" v-show="deliveryCycle == ''" />
						<img class="icon-img ml7" src="@/assets/images/add.png" @click="handleEdit" title="新增" alt="" v-show="deliveryCycle == ''" />
					</div>
				</div>
				<!-- 客商调序 -->
				<el-table
					:data="tableData"
					v-show="tabPosition == 'left'"
					v-if="tableData.length > 0"
					ref="multipleTable"
					:header-cell-style="{
						background: '#C8CCD7',
						color: '#333333',
						height: '25px',
					}"
					v-el-table-infinite-scroll="tableLoad"
					@selection-change="handleSelectionChange"
					:row-key="
						(row) => {
							return row.dataKey;
						}
					"
					:cell-style="cellStyle"
					@cell-click="editRow"
					border
					style="width: 100%">
					<el-table-column type="selection" :reserve-selection="true" width="70" align="center"></el-table-column>
					<el-table-column
						v-show="tableData"
						v-for="(value, index) in titles"
						:key="index"
						:show-overflow-tooltip="true"
						:label="value.title"
						:min-width="index == 0 ? 60 : value.maxWidth">
						<template slot-scope="scope">
							{{ scope.row.datas[index] }}
						</template>
					</el-table-column>
					<el-table-column label="调序" width="100">
						<template slot-scope="scope">
							<i class="el-icon-bottom ml15 opeartion" @click="sortDown(scope.row, 2)" v-if="scope.$index + 1 != tableData.length"></i>
							<i class="el-icon-top ml15 opeartion" @click="sortDown(scope.row, 1)" v-if="scope.$index > 0"></i>
						</template>
					</el-table-column>
				</el-table>
				<div v-show="tabPosition == 'left'" v-else class="tc mt15">暂无数据</div>
				<!-- 配送周期 -->
				<el-table
					:data="deliveryCycleList"
					v-show="tabPosition == 'right'"
					v-if="deliveryCycleList.length > 0"
					ref="deliveryCycleListTable"
					:header-cell-style="{
						background: '#C8CCD7',
						color: '#333333',
						height: '25px',
					}"
					v-el-table-infinite-scroll="tableDeliveryCycleLoad"
					border
					style="width: 100%">
					<el-table-column label="序号" width="70" :show-overflow-tooltip="true" type="index"></el-table-column>
					<el-table-column prop="sapAgentNo" label="客商SAP编码" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="agentName" label="客商简称" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="channelName" label="渠道" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="monSort" label="周一" width="70">
						<template slot-scope="scope">
							<el-checkbox v-model="scope.row.monSort" @change="changeWeek(scope.row, '1', scope.row.monSort)"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column prop="tuesSort" label="周二" width="70">
						<template slot-scope="scope">
							<el-checkbox v-model="scope.row.tuesSort" @change="changeWeek(scope.row, '2', scope.row.tuesSort)"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column prop="wedSort" label="周三" width="70">
						<template slot-scope="scope">
							<el-checkbox v-model="scope.row.wedSort" @change="changeWeek(scope.row, '3', scope.row.wedSort)"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column prop="thurSort" label="周四" width="70">
						<template slot-scope="scope">
							<el-checkbox v-model="scope.row.thurSort" @change="changeWeek(scope.row, '4', scope.row.thurSort)"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column prop="friSort" label="周五" width="70">
						<template slot-scope="scope">
							<el-checkbox v-model="scope.row.friSort" @change="changeWeek(scope.row, '5', scope.row.friSort)"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column prop="satSort" label="周六" width="70">
						<template slot-scope="scope">
							<el-checkbox v-model="scope.row.satSort" @change="changeWeek(scope.row, '6', scope.row.satSort)"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column prop="sunSort" label="周日" width="70">
						<template slot-scope="scope">
							<el-checkbox v-model="scope.row.sunSort" @change="changeWeek(scope.row, '0', scope.row.sunSort)"></el-checkbox>
						</template>
					</el-table-column>
				</el-table>
				<div v-show="tabPosition == 'right'" v-else class="tc mt15">暂无数据</div>
			</div>

			<span slot="footer" class="dialog-footer" v-if="ruleForm.routeId == ''">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
			</span>
		</el-dialog>
		<addMerchants ref="addMerchants" @getAgentList="selectRows"></addMerchants>
		<addCar ref="addCar" @selectCarRows="selectCarRows"></addCar>
		<sortEdit ref="sortEdit" @getList="selectRows"></sortEdit>
		<addRouteUser ref="addRouteUser" @selectUserRows="selectUserRows" @flag="flag" @clearReadonly="clearReadonly"></addRouteUser>
		<!-- 路线编排 -->
		<editRoute ref="editRoute" @selectRows="selectRows"></editRoute>
	</div>
</template>

<script>
import { debounce } from "@/utils/debounce";
import addMerchants from "./add-merchants.vue";
import addCar from "./add-car.vue";
import addRouteUser from "./add-route-user.vue";
import sortEdit from "./sort-edit.vue";
import editRoute from "./edit-route.vue";
export default {
	components: {
		addMerchants,
		addCar,
		addRouteUser,
		sortEdit,
		editRoute,
	},
	data() {
		return {
			dialogVisible: false,
			groupDate: [],
			weeklist: [
				{
					value: "1",
					label: "周一",
				},
				{
					value: "2",
					label: "周二",
				},
				{
					value: "3",
					label: "周三",
				},
				{
					value: "4",
					label: "周四",
				},
				{
					value: "5",
					label: "周五",
				},
				{
					value: "6",
					label: "周六",
				},
				{
					value: "0",
					label: "周日",
				},
			],
			ruleForm: {
				routeCode: "",
				routeId: "",
				routeName: "",
				groupId: "",
				licensePlate: "",
				routeStatus: "Y",
				deliveryCycle: "",
				mainUserCode: "",
				secUserCode: "",
				mainUserName: "",
				secUserName: "",
				carId: "",
				routeType: "",
				routeTag1: "",
				routeTag2: "",
				routeTag3: "",
			},
			rules: {
				routeName: [
					{
						required: true,
						message: "请输入路线名称",
						trigger: "blur",
					},
				],
				groupId: [
					{
						required: true,
						message: "请选择组织结构",
						trigger: "change",
					},
				],
				licensePlate: [
					{
						required: true,
						message: "请选择配送车辆",
						trigger: "change",
					},
				],
				routeStatus: [
					{
						required: true,
						message: "请选择启用状态",
						trigger: "change",
					},
				],
				deliveryCycle: [
					{
						required: true,
						message: "请选择周期",
						trigger: "change",
					},
				],
				mainUserCode: [
					{
						required: true,
						message: "请选择主路线员",
						trigger: "change",
					},
				],
				routeType: [
					{
						required: true,
						message: "请选择路线类型",
						trigger: "change",
					},
				],
			},
			skuList: [],
			codeList: [],
			tableData: [],
			titles: [],
			flagRow: [],
			pageNo: 1,
			pageSize: 50,
			multipleSelection: [],
			secFlag: true,
			selectUserId: {
				mainUserId: "",
				secUserId: "",
			},
			agents: [],
			// left客商调序 right配送周期
			tabPosition: "left",
			// 配送周期
			deliveryCycle: "",
			// 配送周期列表
			deliveryCycleList: [],
			// 配送周期页
			deliveryCyclePageNo: 1,
		};
	},
	created() {},
	methods: {
		cellStyle({ row, column, rowIndex, columnIndex }) {
			if (columnIndex == 1) {
				return "cursor: pointer;";
			}
		},
		init(data) {
			this.$nextTick(() => {
				this.dialogVisible = true;
				this.tabPosition = "left";
				this.pageNo = 1;
				this.deliveryCyclePageNo = 1;
				this.deliveryCycle = "";
				this.ruleForm = {
					routeId: "",
					routeName: "",
					groupId: "",
					licensePlate: "",
					routeStatus: "Y",
					deliveryCycle: "",
					mainUserCode: "",
					secUserCode: "",
					mainUserName: "",
					secUserName: "",
					carId: "",
					routeType: "",
					routeTag1: "",
					routeTag2: "",
					routeTag3: "",
				};
				this.selectUserId = {
					mainUserId: "",
					secUserId: "",
				};
				if (data) {
					this.ruleForm.routeId = data.dataKey;
					// 获取路线信息
					this.getInfo();
					// 获取客商列表
					this.getRouteAgent();
					// 获取配送周期列表
					this.routeDeliveryCycleList();
				} else {
					this.getBusSelectList();
				}
			});
		},
		// 组织部门
		getBusSelectList() {
			let that = this;
			that.$request.post("busSelectList", false, {}).then((res) => {
				if (res) {
					that.groupDate = res.data;
				}
			});
		},
		// 新增修改组织部门
		handleGroup() {
			this.ruleForm.licensePlate = "";
			this.ruleForm.mainUserCode = "";
			this.ruleForm.secUserCode = "";
			this.ruleForm.mainUserName = "";
			this.ruleForm.secUserName = "";
		},
		// 选择的车辆信息
		selectCarRows(val) {
			this.ruleForm.licensePlate = val[0].licensePlate;
			this.ruleForm.carId = val[0].carId;
		},
		//  添加线路员类型
		flag(val) {
			if (val == 1) {
				this.ruleForm.mainUserCode = this.flagRow[0].datas[1];
				this.ruleForm.mainUserName = this.flagRow[0].datas[0];
				this.selectUserId.mainUserId = this.flagRow[0].dataKey;
			} else {
				this.ruleForm.secUserCode = this.flagRow[0].datas[1];
				this.ruleForm.secUserName = this.flagRow[0].datas[0];
				this.selectUserId.secUserId = this.flagRow[0].dataKey;
			}
		},
		// 添加线路员
		selectUserRows(val) {
			this.flagRow = val;
		},
		// 清除副路线员readonly状态
		clearReadonly() {
			this.secFlag = false;
		},
		//  添加客商
		selectRows(val) {
			// 获取客商列表
			this.pageNo = 1;
			this.getRouteAgent();
			if (this.tableData.length > 0) {
				this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
			}
			// 获取配送周期列表
			this.deliveryCyclePageNo = 1;
			this.routeDeliveryCycleList();
			if (this.deliveryCycleList.length > 0) {
				this.$refs.deliveryCycleListTable.bodyWrapper.scrollTop = 0;
			}
		},
		//添加线路成员
		handleRouteUser(val) {
			if (val == 2) {
				this.secFlag = true;
			}
			this.$refs.addRouteUser.init(val, this.selectUserId, this.ruleForm.groupId);
		},
		// 清除副路线员
		handleClear() {
			this.secFlag = true;
			this.ruleForm.secUserCode = "";
			this.ruleForm.secUserName = "";
		},
		// 添加车辆
		handleCar() {
			this.$refs.addCar.init(this.ruleForm);
		},
		// 新增客商
		handleEdit() {
			// 配送周期为全部的时候才允许操作
			if (this.deliveryCycle != "") {
				return;
			}
			this.$refs.addMerchants.init(this.ruleForm.routeId, this.ruleForm.groupId);
		},
		// 地图
		handleMap() {
			this.$refs.editRoute.init(this.ruleForm);
		},
		// 查看/编辑
		editRow(row, column, cell, event) {
			if (column.label == "序号") {
				this.$refs.sortEdit.init(row, this.deliveryCycle);
			}
		},
		// 列多选
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 删除
		deleteRow() {
			// 配送周期为全部的时候才允许操作
			if (this.deliveryCycle != "") {
				return;
			}
			let that = this;
			if (that.multipleSelection.length <= 0) {
				that.$message.error("请先选择!");
				return;
			}
			let userIds = [];
			that.multipleSelection.forEach((item) => {
				userIds.push(item.dataKey);
			});
			that.$confirm("是否确认删除？", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "error",
			})
				.then(() => {
					that.$request
						.post("routeDelAgent", false, {
							recordIds: userIds,
							routeId: that.ruleForm.routeId,
						})
						.then((res) => {
							if (res) {
								that.multipleSelection = []; // 清空选中项数组，实现全选状态清空
								that.$refs.multipleTable.clearSelection(); // 清除当前全选状态
								that.$message.success("删除成功！");
								that.pageNo = 1;
								that.getRouteAgent();
								// 获取配送周期列表
								that.deliveryCyclePageNo = 1;
								that.routeDeliveryCycleList();
							}
						});
				})
				.catch(() => {});
		},
		// 查询路线信息
		getInfo() {
			let that = this;
			that.$request
				.post("routeInfo", false, {
					routeId: that.ruleForm.routeId,
				})
				.then((res) => {
					if (res) {
						that.ruleForm = {
							groupId: res.data.groupId,
							mainUserId: res.data.mainUserId,
							secUserId: res.data.secUserId,
							routeName: res.data.routeName,
							licensePlate: res.data.licensePlate,
							routeStatus: res.data.routeStatus,
							deliveryCycle: res.data.deliveryCycle || res.data.deliveryCycle == 0 ? res.data.deliveryCycle.toString() : "",
							mainUserCode: res.data.mainUserCode,
							secUserCode: res.data.secUserCode,
							mainUserName: res.data.mainUserName,
							secUserName: res.data.secUserName,
							routeCode: res.data.routeCode,
							routeId: that.ruleForm.routeId,
							carId: res.data.carId,
							routeType: String(res.data.routeType),
							routeTag1: res.data.routeTag1,
							routeTag2: res.data.routeTag2,
							routeTag3: res.data.routeTag3,
						};
						that.selectUserId.mainUserId = res.data.mainUserId;
						that.selectUserId.secUserId = res.data.secUserId;
						that.agents = res.data.agents;
					}
				});
		},
		// 表格滚动加载
		tableLoad: debounce(
			function () {
				this.pageNo++;
				this.getRouteAgent("scroll");
			},
			100,
			true,
		),
		// 客商路线列表
		getRouteAgent(type) {
			let that = this;
			that.$request
				.post("routeAgent", false, {
					routeId: that.ruleForm.routeId,
					pageNo: that.pageNo,
					pageSize: that.pageSize,
					deliveryCycle: that.deliveryCycle,
				})
				.then((res) => {
					if (type == "scroll") {
						that.tableData = that.tableData.concat((res.data && res.data.tableDatas) || []);
					} else {
						if (res.data && res.data.tableDatas.length > 0) {
							that.titles = res.data.titles;
							that.tableData = res.data.tableDatas;
						} else {
							that.titles = [];
							that.tableData = [];
						}
					}
				});
		},
		// 上移下移
		sortDown(row, val) {
			let that = this;
			that.$request
				.post("routeSort", false, {
					deliveryCycle: this.deliveryCycle,
					recordId: row.dataKey,
					removeFlag: val,
				})
				.then((res) => {
					if (res.code == "0") {
						that.$message.success(val == 1 ? "上移成功！" : "下移成功！");
						that.selectRows();
					}
				});
		},
		// 保存
		submitForm: debounce(
			function () {
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						if (this.ruleForm.mainUserCode == this.ruleForm.secUserCode) {
							this.$message.error("主路线员和副路线员不能一致!");
							return;
						}
						this.$confirm("是否确认保存？", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
						})
							.then(() => {
								if (this.ruleForm.routeId == "") {
									this.addRow();
								} else {
									this.updateRow();
								}
							})
							.catch(() => {});
					} else {
						return false;
					}
				});
			},
			1000,
			true,
		),
		// 新增
		addRow() {
			let that = this;
			that.$request
				.post("routeAdd", true, {
					groupId: that.ruleForm.groupId,
					routeName: that.ruleForm.routeName,
					licensePlate: that.ruleForm.licensePlate,
					routeStatus: that.ruleForm.routeStatus,
					mainUserCode: that.ruleForm.mainUserCode,
					secUserCode: that.ruleForm.secUserCode,
					mainUserName: that.ruleForm.mainUserName,
					secUserName: that.ruleForm.secUserName,
					carId: that.ruleForm.carId,
					routeType: that.ruleForm.routeType,
					routeTag1: that.ruleForm.routeTag1,
					routeTag2: that.ruleForm.routeTag2,
					routeTag3: that.ruleForm.routeTag3,
				})
				.then((res) => {
					if (res.code == "0") {
						that.$message.success("保存成功！");
						that.ruleForm.routeId = res.data.routeId;
						// 获取路线信息
						that.getInfo();
						// 获取客商列表
						that.getRouteAgent();
						// 获取配送周期列表
						that.routeDeliveryCycleList();
					}
				});
		},
		// 修改
		updateRow() {
			let that = this;
			that.$request
				.post("routeUpdate", true, {
					groupId: that.ruleForm.groupId,
					routeId: that.ruleForm.routeId,
					routeName: that.ruleForm.routeName,
					licensePlate: that.ruleForm.licensePlate,
					routeStatus: that.ruleForm.routeStatus,
					deliveryCycle: that.ruleForm.deliveryCycle,
					mainUserCode: that.ruleForm.mainUserCode,
					secUserCode: that.ruleForm.secUserCode,
					mainUserName: that.ruleForm.mainUserName,
					secUserName: that.ruleForm.secUserName,
					carId: that.ruleForm.carId,
					routeType: that.ruleForm.routeType,
					routeTag1: that.ruleForm.routeTag1,
					routeTag2: that.ruleForm.routeTag2,
					routeTag3: that.ruleForm.routeTag3,
				})
				.then((res) => {
					if (res) {
						that.dialogVisible = false;
						that.$message.success("保存成功！");
						that.$emit("getList");
					}
				});
		},
		// 取消
		cancle() {
			this.dialogVisible = false;
			this.$refs["ruleForm"].resetFields();
			this.$emit("getList");
		},
		// 配送周期下拉触发事件
		changeDeliveryCycle() {
			this.pageNo = 1;
			this.getRouteAgent();
		},
		// 表格滚动加载
		tableDeliveryCycleLoad: debounce(
			function () {
				this.deliveryCyclePageNo++;
				this.routeDeliveryCycleList("scroll");
			},
			100,
			true,
		),
		// 配送周期列表
		routeDeliveryCycleList(type) {
			let that = this;
			that.$request
				.post("routeDeliveryCycleList", false, {
					pageNo: that.deliveryCyclePageNo,
					pageSize: that.pageSize,
					routeId: that.ruleForm.routeId,
				})
				.then((res) => {
					if (type == "scroll") {
						for (const item of res.data.list) {
							item.monSort = item.monSort > 0 ? true : false;
							item.tuesSort = item.tuesSort > 0 ? true : false;
							item.wedSort = item.wedSort > 0 ? true : false;
							item.thurSort = item.thurSort > 0 ? true : false;
							item.friSort = item.friSort > 0 ? true : false;
							item.satSort = item.satSort > 0 ? true : false;
							item.sunSort = item.sunSort > 0 ? true : false;
						}
						that.deliveryCycleList = that.deliveryCycleList.concat((res.data && res.data.list) || []);
					} else {
						if (res.data && res.data.list.length > 0) {
							for (const item of res.data.list) {
								item.monSort = item.monSort > 0 ? true : false;
								item.tuesSort = item.tuesSort > 0 ? true : false;
								item.wedSort = item.wedSort > 0 ? true : false;
								item.thurSort = item.thurSort > 0 ? true : false;
								item.friSort = item.friSort > 0 ? true : false;
								item.satSort = item.satSort > 0 ? true : false;
								item.sunSort = item.sunSort > 0 ? true : false;
							}
							that.deliveryCycleList = res.data.list;
						} else {
							that.deliveryCycleList = [];
						}
					}
				});
		},
		// 点击week单选框
		changeWeek(dt, week, flag) {
			let that = this;
			that.$request
				.post("routeDeliveryCycleEdit", false, {
					recordId: dt.recordId,
					week: week,
					flag: flag ? "1" : "0",
				})
				.then((res) => {
					if (res.code == "0") {
						that.$message.success("设置成功");
						if (that.deliveryCycle != "") {
							that.pageNo = 1;
							that.getRouteAgent();
						}
					}
				});
		},
	},
	beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.mb0 {
	margin-bottom: 0 !important;
}

.w90 {
	width: 110px;
}

.nc-box {
	padding: 10px;
	border-bottom: 1px solid #dcdfe6;
	color: #606266;
	font-size: 13px;
}

.mb10 {
	margin-bottom: 10px !important;
}

.info-box {
	/deep/ .el-dialog__body {
		padding: 0px 20px 10px;
		overflow-y: auto;
	}
}

.info-title {
	border-top: 2px solid #e5e5e5;
	padding-top: 18px;
}

.el-form--inline .el-form-item {
	margin-right: 0;
}

.el-form-item {
	width: 315px;
}

.w330 {
	width: 330px;
}

.w420 {
	width: 420px !important;
	margin-right: 10px;
}

.w280 {
	width: 280px;
}

.w210 {
	width: 210px;
}

.form-add {
	.el-form-item {
		width: 420px;
	}
}

.info-name {
	display: inline-block;
	width: 140px;
	text-align: right;
}

.opeartion {
	font-size: 18px;
	cursor: pointer;
}

.lh30 {
	line-height: 30px;
}

.el-table {
	// 深度选择器，去除默认的padding
	/deep/ th {
		padding: 5px;
	}

	/deep/ td {
		padding: 5px;
	}
}

.el-icon-search {
	cursor: pointer;
}

.el-icon-circle-close {
	cursor: pointer;
}

.w120 {
	width: 120px;
}

.w80 {
	width: 80px;
}

.ml10 {
	margin-left: 10px;
}

.ml35 {
	margin-left: 35px;
}

.icon-img {
	vertical-align: middle;
}

.f-r {
	float: right;
}

.el-table {
	/deep/ .el-table__fixed::before {
		display: none;
	}
	/deep/ .el-table__fixed-right::before {
		display: none;
	}
	/deep/ .el-table__body-wrapper {
		width: 100% !important;
		max-height: 60vh !important; // 表格高度减去表头的高度
	}
}
</style>
<style>
.el-select-dropdown__wrap {
	max-height: 300px;
}
</style>
